const ACTION_TYPES = {
  PAGINATE: "PAGINATE",
  SELECT: "SELECT",
  ADD: "ADD",
  UPDATE: "UPDATE",
  REMOVE: "REMOVE",
};

const reducers = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.PAGINATE: {
      return {
        ...state,
        rows: action.data.data,
        page: action.data.paginatorInfo.currentPage,
        perPage: action.data.paginatorInfo.perPage,
        total: action.data.paginatorInfo.total,
        currentPage: action.data.paginatorInfo.currentPage,
      };
    }
    case ACTION_TYPES.ADD: {
      return {
        ...state,
        rows: [...state.rows, action.data],
      };
    }
    case ACTION_TYPES.REMOVE: {
      console.log(action.data);
      return {
        ...state,
        rows: state?.rows?.filter(({ id }) => id !== action.data),
      };
    }
    default: {
      return state;
    }
  }
};

export { reducers, ACTION_TYPES };
